import React, {   useState } from 'react'
import {  Form, Input, App,Modal, DatePicker, InputNumber } from 'antd'
import { useQiyeyhzhAddMutation } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';
function AccountAdd(props) {
    const [open,setOpen] = useState(false)
    const{message} = App.useApp();    
    const [form] = Form.useForm(); 
    const [submit] = useQiyeyhzhAddMutation();
    const [info,setInfo] = useState({       
        'qyyhzh_qy_id': props.qy_id,
        'qyyhzh_qy_name': props.qy_name,
        'qyyhzh_name': '',
        'qyyhzh_full_name': '',
        'qyyhzh_code': '',
        'qyyhzh_firm': '',
        'qyyhzh_uid': props.yh_id,
        'qyyhzh_uname': props.yh_name,
        'qyyhzh_content': ''
    })
    
 
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open}
                title='新增银行账户'
                width={800}
                onCancel={() => {setOpen(false)}} 
                onOk={() => {                    
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功')   
                            form.resetFields();  
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败：'+res.data.Message)
                        }
                    }) 
                }}            
            >
                <Form                                
                    form={form}
                    style={{width: '100%' }}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 5}}                                 
                >   
                    <Form.Item name="qyyhzh_name" wrapperCol={{span:12}} required label='账户昵称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,qyyhzh_name:e.target.value}))
                        }}/>
                    </Form.Item>                 
                    <Form.Item name="qyyhzh_full_name" wrapperCol={{span:12}} required label='账户全称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,qyyhzh_full_name:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item name="qyyhzh_code" wrapperCol={{span:12}} label='账号'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,qyyhzh_code:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item name="qyyhzh_firm" wrapperCol={{span:12}} label='开户银行'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,qyyhzh_firm:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item name="qyyhzh_content" wrapperCol={{span:12}}  label='备注'>                        
                        <Input onChange={(e) => {    
                            setInfo(prevState=>({...prevState,qyyhzh_content:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item name="qyyhzh_qc_amount" wrapperCol={{span:12}}  label='期初金额'>                        
                        <InputNumber 
                            placeholder='请输入期初金额'
                            style={{width: '100%'}}
                            min={0.01}
                            max={99999999.99}
                            step={0.01}
                            precision={2}
                            onChange={(value) => {    
                                const bankRemain = props.bankRemain || 0;
                                const finalValue = (value || 0) + bankRemain;
                                setInfo(prevState=>({...prevState,qyyhzh_qc_amount:finalValue}))
                            }}
                        />
                    </Form.Item>
                    <Form.Item name="qyyhzh_qc_date" wrapperCol={{span:12}}  label='期初日期'>                        
                        <DatePicker onChange={(value) => {    
                            setInfo(prevState=>({...prevState,qyyhzh_qc_date:value.format('YYYY-MM-DD')}))
                        }}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default AccountAdd